import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import reducerRegistry from './ReducerRegistry';
const middleWares = [thunkMiddleware];
const combine = (reducers) => {
    if (Object.keys(reducers).length !== 0) {
        return combineReducers(reducers);
    }
    // eslint-disable-next-line
    return () => { };
};
const reducer = combine(reducerRegistry.getReducers());
const store = createStore(reducer, applyMiddleware(...middleWares));
// Replace the store's reducer whenever a new reducer is registered.
reducerRegistry.setChangeListener((reducers) => store.replaceReducer(combine(reducers)));
export default store;
